import { type SAFonts } from '@atoms/FontPicker';
import {
  Oswald, Poppins, Merriweather, Ultra, Lobster, Philosopher, Comfortaa, Syne, Brygada_1918, Tomorrow, Montserrat, Outfit,
  Arimo, Inconsolata, Overpass, Raleway, Heebo, Inter
} from 'next/font/google';

const oswald = Oswald({ subsets: ['latin'] });
const poppins = Poppins({
  subsets: ['latin'],
  weight: '400',
});
const merriweather = Merriweather({
  subsets: ['latin'],
  weight: '400',
});
const ultra = Ultra({
  subsets: ['latin'],
  weight: '400',
});
const lobster = Lobster({
  subsets: ['latin'],
  weight: '400',
});
const philosopher = Philosopher({
  subsets: ['latin'],
  weight: '400',
});

const comfortaa = Comfortaa({
  subsets: ['latin'],
  weight: '400',
});

const syne = Syne({
  subsets: ['latin'],
  weight: '400',
});

const brygada_1918 = Brygada_1918({
  subsets: ['latin'],
  weight: '400',
});

const tomorrow = Tomorrow({
  subsets: ['latin'],
  weight: '400',
});

const montserrat = Montserrat({
  subsets: ['latin'],
  weight: '400',
});

const outfit = Outfit({
  subsets: ['latin'],
  weight: '400',
});

const heebo = Heebo({
  subsets: ['latin'],
  weight: '400',
});

const inconsolata = Inconsolata({
  subsets: ['latin'],
  weight: '400',
});

const raleway = Raleway({
  subsets: ['latin'],
  weight: '400',
});

const arimo = Arimo({
  subsets: ['latin'],
  weight: '400',
});

const overpass = Overpass({
  subsets: ['latin'],
  weight: '400',
});

const inter = Inter({
  subsets: ['latin'],
  weight: '400',
});

export type FontStyle = {
  fontFamily: string;
  fontStyle?: string;
  fontWeight?: number;
}

export default function useFonts() {
  const getFontStyle = (fontInput: SAFonts | string | FontStyle) => {
    const fonts: Record<SAFonts, FontStyle> = {
      Oswald: oswald.style,
      Poppins: poppins.style,
      Merriweather: merriweather.style,
      Ultra: ultra.style,
      Lobster: lobster.style,
      Philosopher: philosopher.style,
      Comfortaa: comfortaa.style,
      Tomorrow: tomorrow.style,
      Montserrat: montserrat.style,
      Syne: syne.style,
      Outfit: outfit.style,
      Inconsolata: inconsolata.style,
      Arimo: arimo.style,
      Overpass: overpass.style,
      Raleway: raleway.style,
      Heebo: heebo.style,
      'Brygada 1918': brygada_1918.style,
      'Helvetica Neue': {
        fontFamily: 'Helvetica Neue',
        fontStyle: 'normal',
        fontWeight: 400
      },
      'Sans-Serif': {
        fontFamily: 'Sans-Serif',
        fontStyle: 'normal',
        fontWeight: 400
      },
      Flama: {
        fontFamily: 'Flama',
        fontStyle: 'normal',
        fontWeight: 400
      },
      Inter: inter.style,
    };

    if (typeof fontInput === 'object' && fontInput && 'fontFamily' in fontInput) return fontInput;

    if (typeof fontInput === 'string' && (fontInput as SAFonts) in fonts) return fonts[fontInput as SAFonts];

    if (typeof fontInput === 'string') {
      const lower = fontInput.toLowerCase();
      const match = (Object.keys(fonts) as SAFonts[]).find((key) => {
        const k = key.toLowerCase();
        return lower.includes(k) || lower.replace(/\s+/g, '_').includes(k.replace(/\s+/g, '_'));
      });
      if (match) return fonts[match];
    }

    return fonts['Sans-Serif'];
  };

  return {
    getFontStyle,
  };
}
